/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sort-keys */
/* eslint-disable array-callback-return */
import Card from 'components/Containers/Card';
import React, { useEffect, useMemo } from 'react';
import { Col, Row, Spin } from 'antd';
import { useQuery, useQueryClient } from 'react-query';
import TestBankContainer from 'components/Containers/TestBankContainer';
import { schoolTypeCodeOption } from 'constants/optionCommon';
import { getCategory_QuestionType } from './api';
import InsertUpdate from './components/InsertUpdate';
import TreeViewData from './components/TreeViewData';
import { QuestionTypeData } from './type';

const IndexCategoryType = () => {
  const queryClient = useQueryClient();

  const [selectedRecord, setSelectedRecord] = React.useState<QuestionTypeData | null>(null);

  const KEY_GET_LIST = ['KEY_GET_LIST'];
  const { data: allData, isLoading } = useQuery(KEY_GET_LIST, () => getCategory_QuestionType());

  const dataFormat = useMemo(() => {
    if (allData) {
      const formatArr = allData.map((item: any) => ({
        ...item,
        parentId: item.parentId === '00000000-0000-0000-0000-000000000000' ? null : item.parentId,
      }));
      return formatArr;
    }
    return [];
  }, [allData]);

  // Cập nhật lại state setSelectedRecord khi làm mới lại danh sách
  useEffect(() => {
    const findE = dataFormat.find((item: QuestionTypeData) => item.id === selectedRecord?.id);
    setSelectedRecord(findE);
  }, [dataFormat]);

  const onRefreshData = () => {
    queryClient.invalidateQueries(KEY_GET_LIST);
  };

  const onSelectNodes = (nodes: any) => {
    setSelectedRecord(nodes);
  };

  return (
    <TestBankContainer name='Danh mục loại bài tập' parentName='Administration'>
      <Card title='Danh mục loại bài tập' extra={<InsertUpdate allData={dataFormat} selectedRecord={selectedRecord} onSuccess={onRefreshData} />} bodyStyles={{ paddingTop: 0 }}>
        <Spin spinning={isLoading} tip='Đang tải dữ liệu ...'>
          <Row gutter={[12, 12]} style={{ marginTop: 20 }}>
            {schoolTypeCodeOption.map((item, index) => (
              <Col lg={8} md={12} xs={24} key={index}>
                <TreeViewData allData={dataFormat} onSelect={onSelectNodes} schoolType={item.value} selectedKeys={[selectedRecord?.key]} />
              </Col>
            ))}
          </Row>
        </Spin>
      </Card>
    </TestBankContainer>
  );
};
export default IndexCategoryType;
